export function PrivacyPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-display font-bold text-white mb-2">Privacy Policy for DreamPaths</h1>
      <p className="text-dream-400 text-sm mb-8">Last Updated: 5/16/25</p>

      <div className="card space-y-6">
        <section>
          <h2 className="text-xl font-semibold text-white mb-3">1. Introduction</h2>
          <p className="text-dream-300">
            Welcome to DreamPaths (&ldquo;we,&rdquo; &ldquo;our,&rdquo; or &ldquo;us&rdquo;), operated by
            Authentic Creative, LLC, a Delaware company. This Privacy Policy explains how we collect, use,
            disclose, and safeguard your information when you use our DreamPaths application and related
            services (collectively, the &ldquo;Service&rdquo;).
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">2. Information We Collect</h2>
          <p className="text-dream-300 mb-3">We collect the following types of information:</p>
          <p className="text-dream-300 mb-2">a) Personal Information:</p>
          <ul className="list-disc list-inside space-y-1 text-dream-300 mb-4">
            <li>Name</li>
            <li>Email address</li>
            <li>Date of birth</li>
            <li>IP address</li>
            <li>User agent</li>
            <li>Page views</li>
            <li>Dream entries and related data</li>
          </ul>
          <p className="text-dream-300 mb-2">b) Usage Data:</p>
          <ul className="list-disc list-inside space-y-1 text-dream-300 mb-4">
            <li>Log data</li>
            <li>Metrics data</li>
            <li>Location data (mobile app only, with user consent)</li>
          </ul>
          <p className="text-dream-300 mb-2">c) Device Information:</p>
          <ul className="list-disc list-inside space-y-1 text-dream-300">
            <li>Mobile device ID</li>
            <li>Model and manufacturer</li>
            <li>Operating system</li>
            <li>Browser type</li>
            <li>Mobile network information</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">3. How We Use Your Information</h2>
          <p className="text-dream-300 mb-2">We use your information to:</p>
          <ul className="list-disc list-inside space-y-1 text-dream-300">
            <li>Provide and maintain our Service</li>
            <li>Improve and personalize user experience</li>
            <li>Analyze usage of our Service</li>
            <li>Communicate with you</li>
            <li>Provide customer support</li>
            <li>Enforce our Terms of Service</li>
            <li>Protect against, investigate, and deter fraudulent, unauthorized, or illegal activity</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">4. Data Storage and Security</h2>
          <p className="text-dream-300">
            We store dream data securely using industry-standard encryption and cloud software. We use
            Cloudflare and AWS cloud services for data protection.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">5. Sharing of Your Information</h2>
          <p className="text-dream-300 mb-2">
            We do not share your personal information with third parties, except:
          </p>
          <ul className="list-disc list-inside space-y-1 text-dream-300">
            <li>When you choose to share within the DreamPaths community</li>
            <li>
              Anonymized dream data with third-party service providers (e.g., Google Analytics, Google
              Fonts, AI/LLM API providers)
            </li>
            <li>To comply with legal obligations</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">6. Your Rights and Choices</h2>
          <p className="text-dream-300 mb-2">You have the right to:</p>
          <ul className="list-disc list-inside space-y-1 text-dream-300">
            <li>Access and download your dream entries as a JSON file</li>
            <li>Request deletion of your data (in most cases, deletion is immediate)</li>
            <li>Opt-out of marketing emails</li>
            <li>Control location data collection on mobile devices</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">7. Children&rsquo;s Privacy</h2>
          <p className="text-dream-300">
            Our Service is not intended for anyone under the age of 18. We do not knowingly collect personal
            information from children under 18.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">8. Changes to This Privacy Policy</h2>
          <p className="text-dream-300">
            We may update our Privacy Policy from time to time. We will notify you of any changes by email to
            the address associated with your account.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">9. Data Retention</h2>
          <p className="text-dream-300">
            We retain your data for as long as your account is active or as needed to provide you services.
            We may retain certain data in backups and logs, which are regularly cycled.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">10. Cookies</h2>
          <p className="text-dream-300">
            Our web app uses cookies for critical features. You can set your browser to refuse all or some
            browser cookies, but this may affect the functionality of our Service.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">11. International Data Transfers</h2>
          <p className="text-dream-300">
            Your information may be transferred to and maintained on computers located outside of your state,
            province, country, or other governmental jurisdiction where the data protection laws may differ
            from those in your jurisdiction.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">12. Contact Us</h2>
          <p className="text-dream-300 mb-3">
            If you have any questions about this Privacy Policy, please contact us at:
          </p>
          <p className="text-dream-300">Authentic Creative, LLC</p>
          <p className="text-dream-300">365 E Avenida De Los Arboles #B69, Thousand Oaks, CA 91360</p>
          <p className="text-dream-300">
            Email:{' '}
            <a href="mailto:support@dreampaths.com" className="text-dream-200 underline hover:text-white">
              support@dreampaths.com
            </a>
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-white mb-3">13. Additional Information</h2>
          <ul className="list-disc list-inside space-y-1 text-dream-300 mb-4">
            <li>Users can report violations and abusive content to abuse@dreampaths.com</li>
            <li>We use meta-data from users&rsquo; dreams to train our internal AI models</li>
            <li>
              Users may consent to have their dream data used in future data training, which we may retain
              indefinitely
            </li>
            <li>Commercial use of dream analysis is allowed with proper attribution to DreamPaths</li>
          </ul>
          <p className="text-dream-300">
            This Privacy Policy is effective as of 8/22/24 and will remain in effect except with respect to
            any changes in its provisions in the future, which will be in effect immediately after being
            posted on this page.
          </p>
        </section>
      </div>
    </div>
  );
}
